/**
 * DataPanel - Shared Component
 * 
 * Displays structured data in a consistent panel format.
 * Used for movesets, stats, details across all sections.
 * 
 * Design System: Information Component - Actionable Information
 */

import React from 'react';

const DataPanel = ({
  title,
  data,
  variant = 'default', // 'default' | 'moveset' | 'stats' | 'details'
  children,
  className = ''
}) => {
  // If children provided, render them
  if (children) {
    return (
      <div className={`bg-gradient-to-r from-slate-50 to-blue-50 rounded-lg p-4 border-l-3 border-blue-400 ${className}`}>
        {title && (
          <h4 className="text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wide">
            {title}
          </h4>
        )}
        {children}
      </div>
    );
  }

  // Render data object as key-value pairs
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    return (
      <div className={`bg-gradient-to-r from-slate-50 to-blue-50 rounded-lg p-4 border-l-3 border-blue-400 ${className}`}>
        {title && (
          <h4 className="text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wide">
            {title}
          </h4>
        )}
        <div className="space-y-2">
          {Object.entries(data).map(([key, value]) => (
            <div key={key} className="flex justify-between items-center">
              <span className="text-sm text-gray-600">{key}</span>
              <span className="text-sm font-semibold text-gray-900">{value}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Render array as list
  if (Array.isArray(data)) {
    return (
      <div className={`bg-gradient-to-r from-slate-50 to-blue-50 rounded-lg p-4 border-l-3 border-blue-400 ${className}`}>
        {title && (
          <h4 className="text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wide">
            {title}
          </h4>
        )}
        <div className="space-y-2">
          {data.map((item, index) => (
            <div key={index} className="text-sm text-gray-900">
              {item}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return null;
};

export default DataPanel;
